export default "__VITE_ASSET__CZ_oAm72__"